/*
 * @Author: Chao Yang
 * @Date: 2020-09-07 17:14:19
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-09-07 17:15:08
 */
import { Injectable, EventEmitter } from '@angular/core';
import { AdDateRangeModel } from './ad-date-range-model';

@Injectable()
export class AdDateRangeEventService {
  public dateClick: EventEmitter<any> = new EventEmitter<any>();

  public toolClick: EventEmitter<any> = new EventEmitter<any>();

  public dateRangeClick: EventEmitter<any> = new EventEmitter<any>();
  public rangeValueChange: EventEmitter<AdDateRangeModel> = new EventEmitter<
    AdDateRangeModel
  >();

  public close: EventEmitter<any> = new EventEmitter<any>();
}
